import { render, staticRenderFns } from "./DlgCompanyNew.vue?vue&type=template&id=b7db9148&scoped=true"
import script from "./DlgCompanyNew.vue?vue&type=script&lang=ts"
export * from "./DlgCompanyNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7db9148",
  null
  
)

export default component.exports